<template>
  <mdb-container fluid>

    <div class="container">
      <section class="section section-blog-fw mt-5 pb-3 wow fadeIn">

        <div class="row">
          <div class="col-md-12">
            <!--Featured image-->
            <div class="card card-cascade wider reverse">
              <div class="view view-cascade overlay">
                <img class="pd-5"
                  :src="announcement.Image"
                  :alt="announcement.Title"
                />
                <a>
                  <div class=""></div>
                </a>
              </div>

              <div class="card-body card-body-cascade text-center">
                <h2>
                  <a><strong v-text="announcement.Title"></strong></a>
                  <p v-text="announcement.Publish"></p>
                </h2>
              </div>
            </div>

            <div class="excerpt mt-5 wow fadeIn white z-depth-1 mb-4 pd-25" data-wow-delay="0.3s" v-html="announcement.Body">
              
            </div>
          </div>
        </div>

      </section>
      
    </div>

  </mdb-container>
</template>

<script>
import {
    mdbContainer,
  mdbNavbar,
  mdbNavItem,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbInput,
  mdbNavbarBrand,
  mdbTextarea
} from "mdbvue";


import announcementApi from "@/api/announcementApi";

export default {
  name: "About",
  components: {
    mdbContainer,
    mdbNavbar,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbInput,
    mdbNavbarBrand,
    mdbTextarea
  },
  data() {
    return {
      announcement:{}
    };
  },
  mounted() {
    
    let announcementId = this.$route.params.announcementId;

    announcementApi.getAnnouncement(announcementId).then(
      ({ data }) => {
        this.announcement = data;
      },
      (r) => {}
    );
    
  },
};
</script>

<style scoped>
.navbar {
  background-color: #6f7782 !important;
}
</style>
